var React = require('react');

function TabletIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".tablet-icon-svg-1{fill:#fff;}.tablet-icon-svg-2{fill:#bdbdbd;}")),React.createElement("rect",{"className":"tablet-icon-svg-1","x":"2","y":"2","width":"10","height":"7","rx":"2","key":1}),React.createElement("path",{"className":"tablet-icon-svg-2","d":"M10,2a2,2,0,0,1,2,2V7a2,2,0,0,1-2,2H4A2,2,0,0,1,2,7V4A2,2,0,0,1,4,2h6m0-2H4A4,4,0,0,0,0,4V7a4,4,0,0,0,4,4h6a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4Z","key":2}),React.createElement("rect",{"className":"tablet-icon-svg-1","x":"6","y":"7","width":"2","height":"1","rx":"0.5","key":3}),React.createElement("path",{"className":"tablet-icon-svg-2","d":"M7.5,7h-1a.5.5,0,0,0,0,1h1a.5.5,0,0,0,0-1Z","key":4})]);
}

TabletIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 14 11","width":"14","height":"11"};

module.exports = TabletIcon;

TabletIcon.default = TabletIcon;
